import { useFlag } from 'shared/settings/FeatureToggles';
import { SettingsSubscriptionPage } from '../../settings/SettingsSubscriptionDetailsPage';
import { SettingsSubscriptionLegacyPage } from '../../settings/SettingsSubscriptionDetailsLegacyPage';
import { CarrierWebviewHeader } from '../CarrierWebviewHeader';

export function SubscriptionPage() {
  const isSeatBasedPriceEnabled = useFlag('seats_based_pricing');

  return (
    <CarrierWebviewHeader>
      {isSeatBasedPriceEnabled ? (
        <SettingsSubscriptionPage />
      ) : (
        <SettingsSubscriptionLegacyPage />
      )}
    </CarrierWebviewHeader>
  );
}
